"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrillToUrlFiltersWithResolvedValues = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var configSelectors_1 = require("../../store/config/configSelectors");
var filterValuesResolver_1 = require("./common/filterValuesResolver");
var queries_1 = require("../../queries");
var types_1 = require("../../../types");
var queryCall_1 = require("../../store/_infra/queryCall");
function getDrillToUrlFiltersWithResolvedValues(ctx, widgetRef) {
    var effectiveFilters, filters, enableFilterValuesResolutionInDrillEvents, resolvedFilterValues;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(queryCall_1.query, queries_1.queryWidgetFilters(widgetRef, null))];
            case 1:
                effectiveFilters = _a.sent();
                filters = effectiveFilters.filter(types_1.isDashboardFilter);
                return [4 /*yield*/, effects_1.select(configSelectors_1.selectEnableFilterValuesResolutionInDrillEvents)];
            case 2:
                enableFilterValuesResolutionInDrillEvents = _a.sent();
                if (!enableFilterValuesResolutionInDrillEvents) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(filterValuesResolver_1.resolveFilterValues, filters, ctx.backend, ctx.workspace)];
            case 3:
                resolvedFilterValues = _a.sent();
                return [2 /*return*/, { filters: filters, resolvedFilterValues: resolvedFilterValues }];
            case 4: return [2 /*return*/, { filters: filters }];
        }
    });
}
exports.getDrillToUrlFiltersWithResolvedValues = getDrillToUrlFiltersWithResolvedValues;
//# sourceMappingURL=getDrillToUrlFilters.js.map